// extracted by mini-css-extract-plugin
module.exports = {"GalleryDesktop":"Gallery_GalleryDesktop__i5UiA","GalleryMobile":"Gallery_GalleryMobile__kBqdm","Image":"Gallery_Image___YqaA","ImageIn":"Gallery_ImageIn__KRGSg"};